import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CurrencyFormatPipe } from '../../../shared/pipes/currency-format.pipe';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { GuaranteesTableComponent } from '../guarantees-table/guarantees-table.component';

@Component({
  selector: 'acs-hospitalisation-evacuation-option-section',
  imports: [
    CurrencyFormatPipe,
    TranslatePipe,
    MatRadioGroup,
    MatRadioButton,
    ReactiveFormsModule,
    GuaranteesTableComponent
  ],
  templateUrl: './hospitalisation-evacuation-option-section.component.html',
  styleUrl: `./hospitalisation-evacuation-option-section.component.scss`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HospitalisationEvacuationOptionSectionComponent {
  @Input({ required: true }) fc!: FormControl;
}
